"use client";

import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QuestionsFrQuentes() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const faqs = [{
    question: "Qu'est-ce qui cause généralement un drain bouché?",
    answer: "Les blocages sont souvent causés par l'accumulation de graisses, de résidus de savon, de cheveux ou de racines d'arbres s'infiltrant dans les conduits. Nos techniques de débouchage haute pression éliminent ces obstructions efficacement."
  }, {
    question: "Quand devrais-je demander une inspection par caméra?",
    answer: "Une inspection est recommandée si vous subissez des refoulements fréquents, avant l'achat d'une propriété, ou pour localiser précisément un bris structurel sans creuser inutilement."
  }, {
    question: "Quels sont vos tarifs pour un débouchage standard?",
    answer: "Nos services de débouchage spécialisés débutent à 275$. Le prix final dépend de la complexité de l'obstruction et de l'équipement requis pour rétablir un débit optimal."
  }, {
    question: "Offrez-vous des services d'urgence à Montréal?",
    answer: "Oui, OT Solution intervient rapidement à Montréal, Laval, Longueuil et sur les Rives Nord et Sud. Nous priorisons les situations critiques pour minimiser les dommages à votre propriété."
  }, {
    question: "Est-ce que vous faites de la plomberie générale?",
    answer: "Non. Nous sommes des spécialistes exclusifs du drainage (débouchage et inspection caméra). Cette spécialisation nous permet d'offrir une expertise technique supérieure et des équipements de pointe que les plombiers généraux n'ont pas toujours."
  }, {
    question: "Comment se déroule une inspection par caméra?",
    answer: "Nous insérons une sonde haute définition dans votre drain pour visualiser l'état interne des tuyaux en temps réel. Vous recevez un diagnostic précis et, si nécessaire, un enregistrement vidéo des anomalies détectées."
  }, {
    question: "Vos interventions sont-elles garanties?",
    answer: "Absolument. Nous nous engageons à fournir un travail de précision chirurgicale. Si le problème persiste après notre passage pour la même cause, nous revenons évaluer la situation sans frais supplémentaires."
  }, {
    question: "Comment puis-je prendre rendez-vous?",
    answer: "Vous pouvez nous appeler directement au 438-367-8309 pour une assistance immédiate ou remplir notre formulaire de contact en ligne pour planifier une intervention non-urgente."
  }];
  return <section data-section-id="381" id="questions-fréquentes" className="bg-background text-foreground py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16 md:mb-24 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <p className="font-mono text-xs tracking-[0.2em] text-primary uppercase mb-6">
              [04] Expertise Technique
            </p>
            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-foreground tracking-tighter">
              Des questions
              <br />
              sur vos <em className="italic text-primary font-normal">drains?</em>
            </h2>
          </div>

          <div className="lg:col-span-5 lg:pt-8 flex flex-col justify-end">
            <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed max-w-md mb-6">
              Réponses techniques sur nos services de débouchage et d'inspection caméra à Montréal et les environs.
            </p>
            <Link to="/ContactPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-foreground hover:text-primary transition-colors duration-300 w-fit group">
              Nous contacter
              <ArrowRight className="size-3 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <div ref={listRef} className={`max-w-[800px] mx-auto transition-all duration-700 ease-out ${listVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-t border-border last:border-b border-b-0 data-[state=open]:border-primary/40 group">
                <AccordionTrigger className="py-6 md:py-7 hover:no-underline [&>svg]:hidden text-left group/trigger">
                  <span className="font-default text-lg md:text-xl font-semibold leading-snug text-foreground transition-colors duration-300 group-data-[state=open]:text-primary pr-6">
                    {faq.question}
                  </span>
                  <span className="relative flex items-center justify-center size-6 shrink-0 mt-1">
                    <span className="absolute h-px w-4 bg-foreground transition-colors duration-300 group-data-[state=open]:bg-primary" />
                    <span className="absolute h-4 w-px bg-foreground transition-all duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0 group-data-[state=open]:bg-primary" />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pt-0 pr-12">
                  <p className="font-default text-base leading-[1.7] text-muted-foreground">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}